import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import React, { useCallback, useMemo, useState } from 'react';
import { BreadCrumbItem } from './breadcrumb-item';
import styles from './breadcrumb.module.scss';
const BreadCrumb = ({ children, onSelected, icon = 'chevron', size = 'sm', focusable = true, selectedCrumbIndex = 0, links = [], RTL = false, }) => {
    const [items, setItems] = useState(links.map((link, index) => ({
        id: nanoid(),
        name: link,
        selected: selectedCrumbIndex === index,
    })));
    const handleSelection = useCallback((id, name) => {
        setItems(prev => prev.map(item => ({
            ...item,
            selected: item.id === id,
        })));
        onSelected?.(name);
    }, []);
    const wrapperClass = useMemo(() => classNames(styles.bread_crumbs_wrapper, RTL ? styles.rtl : ''), []);
    return (_jsx("ul", { className: wrapperClass, role: "navigation", "aria-label": "breadcrumbs", children: items.map(({ id, selected, name }, index) => (_jsx(BreadCrumbItem, { child: Array.isArray(children) && children[index], id: id, onSelected: handleSelection, showChevron: index < items.length - 1, icon: icon, size: size, selected: selected, index: index, focusable: focusable, name: name, RTL: RTL }, id))) }));
};
BreadCrumb.displayName = 'BreadCrumb';
export { BreadCrumb };
